import type { FaireProductEntity } from "../../entity_types/product";

export const p_ychfn8hrk4: FaireProductEntity = {
  token: "p_ychfn8hrk4",
  type: "product",
  name: "18K Gold Plated Stainless Steel Green Cubic Zirconia Ring",
  brandToken: "b_wxdny9yjk7",
  brandName: "Norelle",
  imageUrl: "https://cdn.faire.com/fastly/0a8903afd6756a47eefd809cc83caa90879744c8cd9bb1a077fa5c3e0c42d89e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/236a334bf649bef5471a1fe4680d978ea30b8b46b05e8209e395cdd26cd7446d.jpeg",
    "https://cdn.faire.com/fastly/e0724af6d34d009b5f7dc1e2d91a700d93ac0c4e623daf30a0bac50025c3dd37.jpeg",
    "https://cdn.faire.com/fastly/10c115167f389759ea654bb08c97da0d60d9397d69f704b44a2e7a3df7c05070.jpeg",
    "https://cdn.faire.com/fastly/786a3217dbe8aaa0f915bef5a9b61fe4619deae6242d9d9d954afc1d70ccbe40.jpeg",
    "https://cdn.faire.com/fastly/a596df66e5fb98ce5bdcea530f6b6b3797e83e6f76198c7a3ce8475f39b7473e.jpeg",
    "https://cdn.faire.com/fastly/134ca1e0d3d1de49c889b074274e4a3c8563accb72f50ac156654c52f75c0609.jpeg",
    "https://cdn.faire.com/fastly/9ba5aed1a9b16cb2039deddd404816720e5d260c2f5412a755f2e23f7a5987db.jpeg"
  ],
  priceDollars: 8.5,
  description: "An elegant open band ring featuring two faceted green cubic zirconia stones, symbolizing balance and vitality. Crafted from 18K gold plated stainless steel, this piece is waterproof and hypoallergenic, designed for both durability and style.\n\nDimensions\nStone Sizes: 0.54 in & 0.65 in\nWeight: 0.14 oz\nAdjustable Fit (open band design)\n\nProduct Details\nMaterial: Stainless Steel, 18K Gold Plated\nStone: Green Cubic Zirconia\nFinish: Waterproof / Hypoallergenic",
  tags: [],
  msrpDollars: 26,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:21.211Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
